import styled from '@emotion/styled';
import Link from '@zola/zola-ui/src/components/LinkV2/LinkV2';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';
import { FONT } from '@zola/zola-ui/src/styles/emotion';

interface PromoContainerProps {
  backgroundColor?: string;
}

export const PromoContainer = styled.div`
  background-color: {
    ${(props: PromoContainerProps) =>
      props.backgroundColor && props.backgroundColor.length > 0
        ? props.backgroundColor
        : COLORS.COVE_100} !important;
  }
`;

interface PromoTextProps {
  color?: string;
}

export const PromoText = styled(Link)`
  text-align: center;
  color: ${(props: PromoTextProps) =>
    props.color && props.color.length > 0 ? props.color : COLORS.SKY_100} !important;
  &:hover,
  &:active,
  &:focus {
    color: ${(props: PromoTextProps) =>
      props.color && props.color.length > 0 ? props.color : COLORS.SKY_100} !important;
  }

  sup {
    top: -0.5em;
  }

  sub {
    bottom: -0.25em;
  }

  sub,
  sup {
    font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
    position: relative;
  }

  @media (max-width: 1250px) {
    max-width: 300px;
    font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
    line-height: 14px;
  }
`;
